export default __webpack_public_path__ + "static/media/WelcomeView_2B-min.8999bfb8.png";